import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { LRSMap } from 'assets/TS/LRSMap_New';
import * as math from 'mathjs';

import { MapBrowserEvent, Map as OlMap } from 'ol';
import * as olCondition from 'ol/events/condition';
import { containsCoordinate } from 'ol/extent';
import Feature from 'ol/Feature';
import WKT from 'ol/format/WKT';
import MVT from 'ol/format/MVT';
import { Geometry, LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon } from 'ol/geom';
import Draw from 'ol/interaction/Draw';
import Snap from 'ol/interaction/Snap';
import Select from 'ol/interaction/Select';
import Modify from 'ol/interaction/Modify';
import VectorLayer from 'ol/layer/Vector';
import Overlay from 'ol/Overlay';
import { get as getProjection } from 'ol/proj';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import DragBox from 'ol/interaction/DragBox'

import { MainDataMapLayersService } from './main-data-map-layers.service';
import { AttrIndexService } from './attr-index.service';
import { GeometryType } from './common-map.service';
import { BoundaryGeom } from './layer.service';
import { BoundaryFeatProp } from './edit.service';
import { UserService } from './user.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { AddressResult } from './address.service';
import { CommonRequestService, SuccessResponse } from './common-request.service';
import { AppSettings } from 'app/app.settings';
import { ToastrService } from 'ngx-toastr';
import { ColumnFilter, Gfo, GfoService } from './gfo.service';
import { JstsService } from './jsts.service';
import { ContextMenuService } from 'ngx-contextmenu';
import { LayerCategory } from './field-mapping.service';
import { MapParamsConfig } from 'app/components/common-map/common-map.component';
import { MapSharedService } from './map-shared.service';
import { StoredRecord } from 'app/models/data-index.model';
import { MainDataService } from './main-data.service';
import { DoubleClickZoom } from 'ol/interaction';
// import { Control } from 'ol/control';

export interface EditLineTopo {
	startVertex?: {
		feats: Feature[]; // Features that share this vertex as start/end
	};
	endVertex?: {
		feats: Feature[];
	};
}

@Injectable({
  providedIn: 'root'
})
export class MainDataMapService {
	moveWaitTime = 1200;

	isPickingFeat: boolean;

	mapEditing: BehaviorSubject<{
		isOn: boolean; 
		source?: 'control' | 'main';
		selectedId?;
		skipGetTopo?: boolean;
	}> = new BehaviorSubject({
		isOn: false,
		// source: 'control'
	});

	map: LRSMap.Map; // TODO: delete
	mapBS: BehaviorSubject<LRSMap.Map> = new BehaviorSubject(null);

	snapBgEdgePoint: Snap;
	featureSnap: Snap;
	surroundingFeatureSnap: Snap;

	dataSelectInteraction: Select;
	fishboneSelectInteraction: Select;
	topoSelectInteraction: Select;
	topoErrorSelectInteraction: Select;
	addressRelocateSelectInteraction: Select;

	// mergeSelectInteraction: Select;

	dataModify: Modify;
	topojsonModify: Modify;
	drawInteraction: Draw;
	drawSnap: Snap;

	dragBox: DragBox;
	addressRelocateDragBox: DragBox;

	ssapRclLinkEvent;

	private hitTolerance = 5;

	readonly labelContainerId = 'mapLabelContainer';
	labelOverlays: Overlay[] = [];

	// layerControlToggle: Subject<any> = new Subject();

	bgRefLayerUpdate: Subject<any> = new Subject();

	bgBdryLayerUpdate: Subject<any> = new Subject();

	labelPainerSubject: Subject<'start' | 'stop' | 'clear'> = new Subject();

	ssapRclLinkModeBS: BehaviorSubject<{
		isOn: boolean;
		source?: 'main' | 'mapControl'
	}> = new BehaviorSubject({
		isOn: false
	});

	addNewGeomSubject: Subject<any> = new Subject();

	mapMoveendSubject: Subject<any> = new Subject();

	mapLegendBS: BehaviorSubject<{
		show: boolean;
	}> = new BehaviorSubject({
		show: false
	})

	private onMapClick_selectFeature: (e) => any;
	private onMapDblclick: (e) => any;

	// private renderer2: Renderer2;
	constructor(
		@Inject(DOCUMENT) private document: Document,
		private toastr: ToastrService,
		// rendererFactory2: RendererFactory2,
		private attrIndexService: AttrIndexService,
		private requestService: CommonRequestService,
		private contextmenuService: ContextMenuService,
		private gfoService: GfoService,
		private jstsService: JstsService,
		private mainDataService: MainDataService,
		private mapLayerService: MainDataMapLayersService,
		private mapSharedService: MapSharedService,
		private userService: UserService
	) {
		// this.renderer2 = rendererFactory2.createRenderer(null, null);
	}


// #region Interactions
		// addSnapInteraction(map: LRSMap.Map, snapLayerName: string) {
		// 	// Remove previous snap interaction
		// 	if (map.interactions.snap) {
		// 		map.olMap.removeInteraction(map.interactions.snap);
		// 	}
		// 	//
		// 	const snap = new Snap({
		// 		// features: new Collection({
		// 		// 	array: features
		// 		// })
		// 		source: map.addedLayers[snapLayerName].getSource(),
		// 		edge: true,
		// 		pixelTolerance: 30
		// 	});
		// 	map.olMap.addInteraction(snap);
		// 	map.interactions.snap = snap;
		// }
	addSnapInteractionToBgEdgePoint(map: LRSMap.Map, layerName: string) {
		const snap = new Snap({
			source: map.addedLayers[layerName].getSource(),
			edge: false,
		}); 
		map.olMap.addInteraction(snap);
		this.snapBgEdgePoint = snap;
	}
	removeSnapInteractionFromBgEdgePoint(map: LRSMap.Map) {
		map.olMap.removeInteraction(this.snapBgEdgePoint);
		this.snapBgEdgePoint = null;
	}
	// Snap to each other while editing
	addSnapInteractionToFeature(map: LRSMap.Map, layerName: string) {
		const snap = new Snap({
			source: map.addedLayers[layerName].getSource()
		}); 
		map.olMap.addInteraction(snap);
		this.featureSnap = snap;

		// Snap to Surrounding layer
		const snapSurrounding = new Snap({
			source: map.addedLayers[this.mapLayerService.bgSurroundingsLayerName].getSource()
		}); 
		map.olMap.addInteraction(snapSurrounding);
		this.surroundingFeatureSnap = snapSurrounding;
	}
	removeSnapInteractionFromFeature(map: LRSMap.Map) {
		map.olMap.removeInteraction(this.featureSnap);
		this.featureSnap = null;
		//
		map.olMap.removeInteraction(this.surroundingFeatureSnap);
		this.surroundingFeatureSnap = null;
	}

	addDataSelectInteraction(callback, condition, toggleCondition?, style?) {
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		const modifyLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		const selectSingleClick = new Select({
			style: style,
			layers: [dataLayer, modifyLayer],
			hitTolerance: this.hitTolerance,
			condition: condition,
			toggleCondition: toggleCondition || (() => false)
		});
		if (callback) {
			selectSingleClick.on('select', (e) => {
				callback(e, selectSingleClick);
			});
		}
		this.map.olMap.addInteraction(selectSingleClick);
		this.dataSelectInteraction = selectSingleClick;
	}
	// removeDataSelectInteraction() {}
	addFishboneSelectInteraction(layer, callback) {
		const selectFilter = (feat) => {
			if (feat.getProperties()[this.attrIndexService.isFishboneRoadKey] || feat.getProperties()[this.attrIndexService.isFishboneAddrKey]) {
				return true;
			}
		}
		const selectSingleClick = new Select({
			style: this.mapLayerService.getFishboneHighlightStyle,
			layers: [layer],
			toggleCondition: () => false,
			filter: selectFilter
		});
		if (callback) {
			selectSingleClick.on('select', (e) => {
				callback(e, selectSingleClick);
			});
		}
		this.map.olMap.addInteraction(selectSingleClick);
		this.fishboneSelectInteraction = selectSingleClick;
	}
	removeFishboneSelectInteraction() {
		this.map.olMap.removeInteraction(this.fishboneSelectInteraction);
		this.fishboneSelectInteraction = null;
	}
	addTopoSelectInteraction(callback?) {
		const layer = this.map.addedLayers[this.mapLayerService.topojsonLayerName];
		const selectSingleClick = new Select({
			style: (feat, reso) => {
				const drawingStyles = this.mapLayerService.getDataLayerStyle(feat, reso);
				return this.mapLayerService.getDataSelectionStyle(feat, reso, drawingStyles);
			},
			layers: [layer],
			hitTolerance: this.hitTolerance
		});
		selectSingleClick.on('select', async (e) => {
			if (callback) {
				callback(e);
			}
			// let selected = e.selected[0];
			// const featId = selected ? selected.getId() : null;
			// if (featId && this.isTopology) {
			// 	// Find feat on data layer
			// 	selected = this.mapService.map.addedLayers[this.dataLayerName].getSource().getFeatureById(featId);
			// }
			// if (selected && selected.getProperties()[this.attrKey][this.isIdOnlyKey]) {
			// 	await this.updateFeatureDetail(selected.getId());
			// }
			// //
			// this.selectRecordOnTable(featId);
			// //
			// await this.updateSelectedCard(this.selectedRows[0]);
		});
		this.map.olMap.addInteraction(selectSingleClick);
		this.topoSelectInteraction = selectSingleClick;
	}
	removeTopoSelectInteraction() {
		this.map.olMap.removeInteraction(this.topoSelectInteraction);
		this.topoSelectInteraction = null;
	}
	addTopoErrorSelectInteraction(callback?) {
		const layer = this.map.addedLayers[this.mapLayerService.topoErrorLayerName];
		// Add select interaction
		const selectSingleClick = new Select({
			layers: [layer],
			style: (feat) => {
				const dataStyle = this.mapLayerService.getTopoErrorLayerStyle(feat);
				const highlightStyle = this.mapLayerService.getBasicHighlightStyle();
				return [highlightStyle, dataStyle];
			}
		});
		selectSingleClick.on('select', (e) => {
			// let selected = e.selected[0];
			// console.log(selected);
			if (callback) {
				callback(e);
			}
		});
		this.topoErrorSelectInteraction = selectSingleClick;
		this.map.olMap.addInteraction(selectSingleClick);
	}
	removeTopoErrorSelectInteraction() {
		this.map.olMap.removeInteraction(this.topoErrorSelectInteraction);
		this.topoErrorSelectInteraction = null;
	}
	addAddressRelocationInteractions(singleClickCallback, dragboxCallback, condition?) {
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		// Single click
		const selectSingleClick = new Select({
			style: this.dataSelectInteraction.getStyle(),
			layers: [dataLayer],
			hitTolerance: this.hitTolerance,
			condition: condition || undefined,
			toggleCondition: olCondition.platformModifierKeyOnly
		});
		if (singleClickCallback) {
			selectSingleClick.on('select', (e) => {
				singleClickCallback(e, selectSingleClick);
			});
		}
		this.map.olMap.addInteraction(selectSingleClick);
		this.addressRelocateSelectInteraction = selectSingleClick;
		// Drag box
		const dragBox = new DragBox({
			condition: olCondition.platformModifierKeyOnly,
		});
		this.map.olMap.addInteraction(dragBox);
		this.addressRelocateDragBox = dragBox;
		dragBox.on('boxend', () => {
			const boxExtent = dragBox.getGeometry().getExtent();
			const boxFeatures = dataLayer.getSource().getFeaturesInExtent(boxExtent);
			if (dragboxCallback) {
				dragboxCallback(boxFeatures);
			}
		});
	}
	removeAddressRelocationInteractions() {
		if (this.addressRelocateSelectInteraction) {
			this.map.olMap.removeInteraction(this.addressRelocateSelectInteraction);
			this.addressRelocateSelectInteraction = null;
		}
		if (this.addressRelocateDragBox) {
			this.map.olMap.removeInteraction(this.addressRelocateDragBox);
			this.addressRelocateDragBox = null;
		}
	}
		// addLineMergeSelectInteraction(callback?) {
		// 	const layer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		// 	const selectSingleClick = new Select({
		// 		layers: [layer],
		// 		// style: (feat) => {}
		// 	});
		// 	selectSingleClick.on('select', (e) => {
		// 		if (callback) {
		// 			callback(e);
		// 		}
		// 	});
		// 	this.mergeSelectInteraction = selectSingleClick;
		// 	this.map.olMap.addInteraction(selectSingleClick);
		// }
		// removeLineMergeSelectInteraction() {
		// 	this.map.olMap.removeInteraction(this.mergeSelectInteraction);
		// 	this.mergeSelectInteraction = null;
		// }

	addDataModify(modifyStartCallback, modifyEndCallback) {
		if (!this.dataModify) {
			const layerName = this.mapLayerService.dataModifyLayerName;
			const snapLayerName = this.mapLayerService.dataLayerName;
			const modify = new Modify({
				source: this.map.addedLayers[layerName].getSource(),
				insertVertexCondition: olCondition.never
			});
			this.map.olMap.addInteraction(modify);
			this.dataModify = modify;

			this.dataModify.on('modifystart', modifyStartCallback);
			this.dataModify.on('modifyend', modifyEndCallback);

			// Add Draw
			
			// Add Snap
			this.addSnapInteractionToFeature(this.map, snapLayerName);

			return modify;
		}
	}
	removeDataModify() {
		if (this.dataModify) {
			this.map.olMap.removeInteraction(this.dataModify);
			this.dataModify = null;

			this.removeSnapInteractionFromFeature(this.map);
		}
	}
	addDrawInteraction(map: LRSMap.Map, geomType: GeometryType, sourceLayer?) {
		if (!this.drawInteraction) {
			sourceLayer = sourceLayer || map.addedLayers[this.mapLayerService.topojsonLayerName];
			const draw = new Draw({
				source: sourceLayer.getSource(),
				type: geomType
			});
			map.olMap.addInteraction(draw);
			this.drawInteraction = draw;
			// Add drawSnap
			const snap = new Snap({
				source: sourceLayer.getSource(),
				edge: true,
				// pixelTolerance: 30
			});
			map.olMap.addInteraction(snap);
			this.drawSnap = snap;
			//
			this.removeDblClickZoomInteraction(map);
		}
	}
	removeDrawInteraction(map: LRSMap.Map) {
		if (this.drawInteraction) {
			map.olMap.removeInteraction(this.drawInteraction);
			this.drawInteraction = null;
			setTimeout(() => {
				this.addDblClickZoomInteraction(map);
			})
		}
		if (this.drawSnap) {
			map.olMap.removeInteraction(this.drawSnap);
			this.drawSnap = null;
		}
	}
	// Map have doubleClickZoom by default
	addDblClickZoomInteraction(map: LRSMap.Map) {
		let dblClickInteraction;
		map.olMap.getInteractions().getArray().find((interaction) => {
			if (interaction instanceof DoubleClickZoom) {
				dblClickInteraction = interaction;
				return true;
			}
		});
		if (!dblClickInteraction) {
			map.olMap.addInteraction(new DoubleClickZoom());
		}
	}
	removeDblClickZoomInteraction(map: LRSMap.Map) {
		// Remove doubleClickZoom interaction
		let dblClickInteraction;
		map.olMap.getInteractions().getArray().find((interaction) => {
			if (interaction instanceof DoubleClickZoom) {
				dblClickInteraction = interaction;
				return true;
			}
		});
		if (dblClickInteraction) {
			map.olMap.removeInteraction(dblClickInteraction);
		}
	}

	addTopoModifyInteraction(map: LRSMap.Map, modifyendCallback?: Function) {
		const layerName = this.mapLayerService.topojsonLayerName
		const layer = map.addedLayers[layerName];
		const modify = new Modify({
			source: layer.getSource(),
			pixelTolerance: 20,
			insertVertexCondition: (e) => {
				let feat;
				map.olMap.forEachFeatureAtPixel(e.pixel, (f, l) => {
					if (l === layer) {
						feat = f;
					}
				});
				const props = feat ? feat.getProperties() : {};
				return props[this.attrIndexService.attrKey] && props[this.attrIndexService.attrKey][this.attrIndexService.isNewDataKey];
			}
		});
		map.olMap.addInteraction(modify);
		//
		modify.on('modifyend', async e => {
			if (modifyendCallback) {
				modifyendCallback(e);
			}
		});
		this.topojsonModify = modify;

		// Add snap
		this.addSnapInteractionToFeature(map, layerName);
	}
	removeTopoModifyInteraction(map: LRSMap.Map) {
		if (this.topojsonModify) {
			map.olMap.removeInteraction(this.topojsonModify);
			this.topojsonModify = null;

			this.removeSnapInteractionFromFeature(map);
		}
	}

	addDragBoxSelection(map: LRSMap.Map, boxendCallback) {
		const dragBox = new DragBox({
			condition: olCondition.platformModifierKeyOnly,
		});
		map.olMap.addInteraction(dragBox);
		this.dragBox = dragBox;
		dragBox.on('boxend', boxendCallback);
	}

// #endregion



	// Either sourceTable OR sql + primaryKey should be passed
	async getFeaturesFromTileGrid(tileGrid, ext, zoom, sourceTable?: string, filters?: ColumnFilter[], attrList?: string, sql?: string, primaryKey?: string) {
		// attrList = attrList || '*';
		let gfo: Gfo;
		if (filters && filters.length) {
			gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, filters);
		}
		//
		const tileCoordList = [];
		const promises = [];
		tileGrid.forEachTileCoord(ext, zoom, tileCoord => {
			const promise = this.getVectorTile(tileCoord, sourceTable, attrList, gfo, sql, primaryKey);
			promises.push(promise);
			tileCoordList.push(tileCoord);
		});
		let features = [];
		const format = new MVT({
			featureClass: Feature
		});
		let isSample = false;
		// let labelInfo: LabelCalc;
		// if (calcLabel) {
		// 	labelInfo = {
		// 		zoom: zoom,
		// 		minDistByTile: {}
		// 	}
		// }
		await Promise.all(promises).then(rspList => {
			rspList.forEach((rsp, idx) => {
				// console.log('tile: ' + tileCoordList[idx], rsp.misc.ssap_dist_min)
				// if (calcLabel) {
				// 	labelInfo.minDistByTile[tileCoordList[idx]] = rsp.misc.ssap_dist_min;
				// }
				if (rsp.misc.sampled) {
					isSample = true;
				}
				const data = rsp.data.content;
				if (data.type === 'Buffer') {
					const featsOnTile = format.readFeatures(data.data, {
						// dataProjection: getProjection('EPSG:3857'),
						extent: tileGrid.getTileCoordExtent(tileCoordList[idx]),
						featureProjection: getProjection('EPSG:3857'),
					});
					features = features.concat(featsOnTile);
				}
			});
		}).catch(err => {
			this.toastr.error(err.message);
		});
		return {
			features: features,
			isSample: isSample
			// labelCalc: labelInfo
		};
	}
	// Transform ORIGINAL features to records
	// Note: features to transform need to have ids
	transformFeaturesToStoredRecords(originals: Feature[], isIdOnly?: boolean) {
		const wktFormat = new WKT();
		const records: {
			[id: string]: StoredRecord
		} = {};
		const excludeAttrs = ['geometry', 'layer', this.attrIndexService.attrKey]; // Hard coded the not-used attributes that come in tile feature
		originals.map(f => {
			if (!f.getId()) {
				return;
			}
			const attrs = {};
			const props = f.getProperties();
			const propKeys = Object.keys(props);
			propKeys.forEach(k => {
				if (excludeAttrs.find(a => a.toLowerCase() === k.toLowerCase())) {
					return;
				}
				if (k === this.attrIndexService.mapNotesColName || k === this.attrIndexService.qaNotesColName) {
					if (props[k]) {
						attrs[k] = JSON.parse(props[k]);
					}
				} else {
					attrs[k] = props[k];
				}
			});

			const wkt = wktFormat.writeGeometry(f.getGeometry());
			attrs[this.attrIndexService.geomColManual] = wkt;
			const record: StoredRecord = {
				attrs: JSON.parse(JSON.stringify(attrs)),
				originalAttrs: attrs
			}
			if (isIdOnly) {
				record.attrs[this.attrIndexService.isIdOnlyKey] = true;
			}
			records[f.getId()] = record;
		});
		return records;
	}

	// Either sourceTable OR sql + primaryKey should be passed
	private getVectorTile(tileCoord: number[], layerName?: string, attrList?: string, gfo?: Gfo, sql?: string, primaryKey?: string) {
		return new Promise<any>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'azgiv/vectorTile';
			const params: any = {
				x: tileCoord[1],
				y: tileCoord[2],
				z: tileCoord[0]
				// sampleSize: 100
			}
			if (attrList) {
				params.attributeList = attrList;
			}
			if (gfo) {
				params.gfo = JSON.stringify(gfo);
			}
			if (layerName) {
				params.layer = layerName;
			}
			if (sql) {
				params.sql = sql;
				params.primaryKey = primaryKey;
			}
			// if (calcLabel) {
			// 	const ext = calcLabel.ext;
			// 	params.xll = ext[0];
			// 	params.yll = ext[1];
			// 	params.xur = ext[2];
			// 	params.yur = ext[3];
			// 	params.layerId = calcLabel.layerId;
			// }
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				resolve(rsp);
			}, err => reject(err));
		});
	}



	//
	public onMapContextmenu(e: MouseEvent, contextmenu, olMap: OlMap, olLayers: any[], priorityId?): {coords: number[]; feature: Feature; vertex?: number[]} {
		const mapElem = this.document.querySelector('#' + olMap.getTarget());
		const mapRect = mapElem.getBoundingClientRect();
		const pixelOnMap = [e.clientX - mapRect.left, e.clientY - mapRect.top];
		const coords = olMap.getCoordinateFromPixel(pixelOnMap);
		const features = [];
		olMap.forEachFeatureAtPixel(pixelOnMap, (feat, layer) => {
			if (olLayers.indexOf(layer) > -1) {
				features.push(feat);
			}
		}, {
			hitTolerance: 5
		});
		// if (features.length) {
		let feature: Feature, vertex; // TODO


		
		if (priorityId) {
			feature = features.find(f => f.getId() === priorityId);
		}
		// Select feature if:  Feature isn't the currently selected feature or there's no currently selected feature
		if (!feature) {
			feature = features[0];
		}
		// Calculate closest vertex
		if (feature) {
			const closestVertex = this.findClosestVertexOnGeom(feature.getGeometry(), coords);
			if (closestVertex) {
				const vertexPixel = olMap.getPixelFromCoordinate(closestVertex);
				const vertexTolorance = 10;
				if (Math.sqrt(Math.pow(vertexPixel[0] - pixelOnMap[0], 2) + Math.pow(vertexPixel[1] - pixelOnMap[1], 2)) < vertexTolorance) {
					vertex = closestVertex;
				}
			}
		}
		//
		this.contextmenuService.show.next({
			event: e,
			contextMenu: contextmenu,
			item: feature
		});
		e.preventDefault();
		e.stopPropagation();
		return {
			feature: feature,
			vertex: vertex,
			coords: coords
		};
		// }
	}
	moveFeaturesToModifyLayer(feats: any[], originLayer?, updateNetworkTopo?: boolean) {
		if (feats) {
			// Remove feature from original layer
			originLayer = originLayer || this.map.addedLayers[this.mapLayerService.dataLayerName];
			feats.forEach(feat => {
				if (!feat) {
					return;
				}
				originLayer.getSource().removeFeature(feat);
			})
			// Add to modify layer
			const modifyLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
			modifyLayer.getSource().addFeatures(feats);
			// For centerline feature, update its lineTopo
			feats.forEach(feat => {
				if (!feat) {
					return;
				}
				if (feat.getGeometry().getType() === 'LineString' && updateNetworkTopo) {
					this.updateCenterlineTopo(feat);
				}
			})
		}
	}
	moveFeaturesBackFromModifyLayer(feats?: any[], originLayer?, modifyLayer?) {
		// Remove feature from modify layer
		modifyLayer = modifyLayer || this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		// Add feature to data layer
		originLayer = originLayer || this.map.addedLayers[this.mapLayerService.dataLayerName];
		if (feats) {
			originLayer.getSource().addFeatures(feats);
			feats.forEach(feat => {
				modifyLayer.getSource().removeFeature(feat);
			});
		} else {
			const feats = modifyLayer.getSource().getFeatures();
			originLayer.getSource().addFeatures(feats);
			modifyLayer.getSource().clear();
		}
	}
	clearLayer(layerName: string) {
		const layer = this.map.addedLayers[layerName];
		if (!layer) {
			console.log('layer not exist: ', layerName);
		} else {
			layer.getSource().clear();
		}
	}
	clearModifyLayer() {
		const layer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		const source = layer.getSource();
		source.getFeatures().forEach(feat => {
			const props = feat.getProperties();
			props[this.attrIndexService.isFeatOnModifyLayer] = false;
			feat.setProperties(props);
		});
		source.clear();
	}
	checkZoomLevelForTopoEditing() {
		let isOutOfEditLevel: boolean;
		const ext = this.map.olMap.getView().calculateExtent();
		const zoomLevel = this.map.olMap.getView().getZoom();
		const numOfFeats = this.map.addedLayers[this.mapLayerService.dataLayerName].getSource().getFeatures().length; // All features should be within extent
		const topos = this.map.addedLayers[this.mapLayerService.topojsonLayerName].getSource().getFeatures(); // All topos
		const toposWithinExtent = topos.filter(t => {
			const geom = t.getGeometry();
			if (geom.intersectsExtent(ext)) {
				return true;
			}
		}); // Topos within extent
		const numOfTopos = toposWithinExtent.length;
		if (zoomLevel < 5) { // State level
			if (numOfFeats > 1) {
				isOutOfEditLevel = true;
			}
		} else if (zoomLevel < 7) { // County level
			if (numOfFeats > 1) {
				isOutOfEditLevel = true;
			}
		} else if (zoomLevel < 9) { // City level
			if (numOfFeats > 3 || numOfTopos > 50) {
				isOutOfEditLevel = true;
			}
		} else { // Neighborhood level
			if (numOfFeats > 100 || numOfTopos > 10) {
				isOutOfEditLevel = true;
			}
		}
		// Update withinEditLevel property in topojsonLayer
		const prop = {};
		prop[this.attrIndexService.topoLayerIsWithinEditResoKey] = !isOutOfEditLevel;
		this.map.addedLayers[this.mapLayerService.topojsonLayerName].setProperties(prop);
		//
		if (isOutOfEditLevel) {
			this.toastr.clear();
			this.toastr.info('Please zoom in to continue editing');
		}
		return !isOutOfEditLevel;
	}

		// addBoundaryFeature(boundaryGeoms: BoundaryGeom[], map: LRSMap.Map) {
			// const adjacentBoundaries = [];
			// const currentBoundary = [];
			// const wktFormat = new WKT();
			// boundaryGeoms.forEach(i => {
			// 	const feat = wktFormat.readFeature(i.wkt, {
			// 		dataProjection: 'EPSG:4326',
			// 		featureProjection: 'EPSG:3857'
			// 	});
			// 	const prop: BoundaryFeatProp = {
			// 		cusId: i.cusId,
			// 		stateName: i.stateName
			// 	};
			// 	feat.setProperties(prop);
			// 	if (i.cusId === this.userService.getUserInfo().customerId) {
			// 		currentBoundary.push(feat);
			// 	} else {
			// 		adjacentBoundaries.push(feat);
			// 	}
			// });
			// const source = map.addedLayers[this.mapLayerService.countyBoundaryLayerName].getSource();
			// source.clear();
			// source.addFeatures(adjacentBoundaries);
			// //
			// if (currentBoundary.length) {
			// 	const snapSource = map.addedLayers[this.mapLayerService.countyBoundarySelfLayerName].getSource();
			// 	snapSource.clear();
			// 	snapSource.addFeatures(currentBoundary);
			// }
		// }

	updateCenterlineTopo(lineFeat, override?: boolean) {
		let lineTopo: EditLineTopo = lineFeat.getProperties()[this.attrIndexService.lineTopoCol];
		if (!lineTopo) {
			lineTopo = {};
			const prop = {};
			prop[this.attrIndexService.lineTopoCol] = lineTopo;
			lineFeat.setProperties(prop);
		}
		const coords = lineFeat.getGeometry().getCoordinates();
		const dataLayer = this.map.addedLayers[this.mapLayerService.dataLayerName];
		const modifyLayer = this.map.addedLayers[this.mapLayerService.dataModifyLayerName];
		const feats: any[] = dataLayer.getSource().getFeatures().concat(modifyLayer.getSource().getFeatures());
		const selfIdx = feats.findIndex(f => f.getId() === lineFeat.getId());
		if (selfIdx > -1) {
			feats.splice(selfIdx, 1);
		}
		const ext = this.map.olMap.getView().calculateExtent();
		// Calc topo
		const isTerminalVertex = (coord, lineGeom) => {
			const coords = lineGeom.getCoordinates();
			if (this.mapSharedService.isCoordsEqual(coord, coords[0])) {
				return true;
			} else if (this.mapSharedService.isCoordsEqual(coord, coords[coords.length - 1])) {
				return true;
			}
		}
		if (!lineTopo.startVertex || override) {
			const startCoord = coords[0];
			if (containsCoordinate(ext, startCoord)) {
				lineTopo.startVertex = {
					feats: feats.filter(f => f !== lineFeat && isTerminalVertex(startCoord, f.getGeometry()))
				};
			}
		}
		if (!lineTopo.endVertex || override) {
			const endCoord = coords[coords.length - 1];
			if (containsCoordinate(ext, endCoord)) {
				lineTopo.endVertex = {
					feats: feats.filter(f => f !== lineFeat && isTerminalVertex(endCoord, f.getGeometry()))
				};
			}
		}
	}

	getPointPositionToLine(layerId, lineGlobalId: string | number, point: number[]) {
		return new Promise<{side: 'left' | 'right'; azimuth_rad: number;}>((resolve, reject) => {
			const url = AppSettings.serviceRootUrl + 'common/pointToLine';
			const params: any = {
				layerId: layerId,
				globalId: lineGlobalId,
				x: point[0],
				y: point[1]
			};
			this.requestService.requestGet(url, {
				params: params
			}, rsp => {
				resolve(rsp.data);
			}, err => reject(err));
		});
	}
	getPointSideToLine(lineString: LineString, point: number[]): {side: 'left' | 'right'} {
		const closestPoint = lineString.getClosestPoint(point);
		const lineCoords = lineString.getCoordinates();
		const positionIndexes = this.mapSharedService.findCoordPositionOnLine(closestPoint, lineCoords);
		if (!positionIndexes) {
			return;
		}
		const x = positionIndexes[0];
		const matrixCollinear = [
			[lineCoords[x][0], lineCoords[x][1], 1],
			[lineCoords[x + 1][0], lineCoords[x + 1][1], 1],
			[point[0], point[1], 1]
		];
		const determinant = math.det(matrixCollinear);
		const side = determinant > 0 ? 'left' : 'right';
		return {
			side: side
		}
	}
	addLabelElem(featureId, centerlineSide: 'left' | 'right', text: string, coord: number[], rotateAngle?: number) {
		const parent = this.document.getElementById(this.labelContainerId);
		if (!parent) {
			return;
		}
		// Create label element
		let elemId = `mapLabel-${centerlineSide}-${featureId}`;
		let label = this.document.getElementById(elemId);
		if (!label) {
			label = this.document.createElement('div');
			label.classList.add('map-label-item');
			label.setAttribute('id', elemId);
			parent.appendChild(label);
		}
		label.innerHTML = `${text}`;
		rotateAngle = rotateAngle || 0;
		label.style.transform = `rotate(${rotateAngle}deg)`;

		// Create label overlay
		let overlay = this.map.olMap.getOverlayById(elemId);
		if (!overlay) {
			overlay = new Overlay({
				id: elemId,
				element: label,
				// offset: [10, 0],
				positioning: 'center-center'
			});
			this.labelOverlays.push(overlay);
			this.map.olMap.addOverlay(overlay);
		}
		overlay.setPosition(coord);
		return overlay;
	}
	toggleLabelElemVisib(isShow) {
		const labelElems = this.document.querySelectorAll('.map-label-item');
		if (!isShow) {
			Array.from(labelElems).forEach(e => {
				(<HTMLElement>e).style.display = 'none';
			});
			return false;
		} else {
			Array.from(labelElems).forEach(e => {
				(<HTMLLIElement>e).style.display = '';
			});
			return true;
		}
	}
	
	
	findClosestVertexOnGeom(geom: Geometry, coord: number[]) {
		const type: GeometryType = geom.getType();
		const points: number[][] = [];
		switch (type) {
			case 'Point':
				points.push((<Point>geom).getCoordinates());
			case 'MultiPoint':
			case 'LineString':
				const coordinates = (<MultiPoint | LineString>geom).getCoordinates();
				coordinates.forEach(c => points.push(c));
				break;
			case 'MultiLineString':
			case 'Polygon':
				const coordinatesArr = (<MultiLineString | Polygon>geom).getCoordinates();
				coordinatesArr.forEach(arr => {
					arr.forEach(c => points.push(c));
				});
				break;
			case 'MultiPolygon':
				const polygonCoordsArr = (<MultiPolygon>geom).getCoordinates();
				polygonCoordsArr.forEach(polygon => {
					polygon.forEach(arr => {
						arr.forEach(c => points.push(c));
					});
				})
				break;
			default:
				console.log('geom type not handled');
		}
		const multiPoint = new MultiPoint(points);
		return multiPoint.getClosestPoint(coord);
	}

	zoomToAddress(addr: AddressResult) {
		if (addr.boundsExtent) {
			this.map.olMap.getView().fit(addr.boundsExtent);
		} else if (addr.coord) {
			const center = addr.coord;
			const zoom = 12;
			this.map.olMap.setView(
				new View({
					center: center,
					zoom: zoom,
				})			
			);
			setTimeout(() => {
				// Add place marker
				this.addPlaceMarker(addr.coord);
			});	
		}
	}
	// Add a marker
	addPlaceMarker(coord: number[]) {
		if (!coord || (typeof(coord[0]) !== 'number' || Number.isNaN(coord[0])) || (typeof(coord[1]) !== 'number' || Number.isNaN(coord[1]))) {
			console.log('coordinate not valid');
			return;
		}
		var placeMarkerFeature = new Feature({
			geometry: new Point(coord)
		});
		const layer = (<VectorLayer<any>>this.map.addedLayers[this.mapLayerService.placeMarkerLayerName]);
		layer.getSource().clear();
		layer.getSource().addFeature(placeMarkerFeature);
	}

	// My Layers
	// Hard Code
	// Switch layer orders when changing layer.
	// Address Layer: dataLayer on top, Other layers: dataLayer under topoLayer and errorLayer
	reOrderQcLayers(map: LRSMap.Map, myLayer: {category: LayerCategory}) {
		if (!map) { return; }
		let dataLayer, dataLayerIdx;
		// Current layers should be BaseMaps, dataLayer, errorLayer, topoLayer
		const layers = map.olMap.getLayers();
		// Find dataLayer and its index
		layers.forEach((l, idx) => {
			if (l.get('layerName') === this.mapLayerService.dataLayerName) {
				dataLayer = l;
				dataLayerIdx = idx;
			}
		});
		// For address point layer
		// Remove data layer and add it at the end of layers
		if (myLayer.category.code === this.attrIndexService.cateCodeAddress) {
			layers.removeAt(dataLayerIdx);
			layers.setAt(layers.getLength(), dataLayer);
		} else if (myLayer.category.code !== this.attrIndexService.cateCodeAddress && dataLayerIdx !== 1) {
		// For other layers. If dataLayerIdx isn't 1, it means it's been moved by address point layer
		// Remove dataLayer and insert it at position 1
			layers.removeAt(dataLayerIdx);
			layers.insertAt(1, dataLayer);
		}
	}

	// Filter features within extent
	filterFeaturesInExtent(feats: Feature[], ext: number[]) {
		return feats.filter(f => {
			const geom = f.getGeometry();
			return geom.intersectsExtent(ext);
		});
	}

	startPickOnMap(map: LRSMap.Map, layerNames: string[], onSelectCallback: (result: {feat; location; e}) => any, autoEndCallback?, cursor?) {
		if (this.onMapClick_selectFeature) {
			this.endPickOnMap(map);
		}
		cursor = cursor || 'crosshair';
		this.mapSharedService.changeCursor(map.olMap, cursor);
		const layers = layerNames.map(name => {
			return map.addedLayers[name];
		})

		this.onMapClick_selectFeature = async e => {
			const point = e.coordinate;
			const pixel = e.pixel;
			const feats = []
			const featsByLayer = {};
			map.olMap.forEachFeatureAtPixel(pixel, (feat, layer) => {
				if (layers.indexOf(layer) === -1) { return; }
				feats.push(feat);
				const layerName = layer.getProperties().layerName;
				if (!featsByLayer[layerName]) {
					featsByLayer[layerName] = [];
				}
				featsByLayer[layerName].push(feat);
			}, {
				hitTolerance: 10
			});
			const tempLayer = new VectorLayer({
				source: new VectorSource({
					features: feats
				})
			});
			const feat = tempLayer.getSource().getClosestFeatureToCoordinate(point);
			if (onSelectCallback) {
				onSelectCallback({
					feat: feat,
					location: point,
					e: e
				});
			}
			if (autoEndCallback) {
				setTimeout(() => {
					this.endPickOnMap(map);
					autoEndCallback();
				}, 500); // setTimeout so that selectFromMapCondition can kick in
			}
		}
		this.isPickingFeat = true;
		map.olMap.on('singleclick', this.onMapClick_selectFeature);
	}
	endPickOnMap(map: LRSMap.Map) {
		this.isPickingFeat = false;
		this.mapSharedService.changeCursor(map.olMap, '');
		if (this.onMapClick_selectFeature) {
			map.olMap.un('singleclick', this.onMapClick_selectFeature);
			this.onMapClick_selectFeature = null;
		}
	}
	addMapDblclickStop(map: LRSMap.Map, callback?) {
		this.onMapDblclick = (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (callback) {
				callback();
			}
			this.removeMapDblclickStop(map);
		}
		map.olMap.on('dblclick', this.onMapDblclick);
	}
	removeMapDblclickStop(map: LRSMap.Map) {
		if (this.onMapDblclick) {
			map.olMap.un('dblclick', this.onMapDblclick);
			this.onMapDblclick = null;
		}
	}

	resetFeaturesGeom(ids: any[], layerName?: string) {
		layerName = layerName || this.mapLayerService.dataLayerName;
		const layer: VectorLayer<VectorSource> = this.map.addedLayers[layerName];
		const wktFormat = new WKT();
		ids.forEach(id => {
			const attrs = this.mainDataService.getDataAttrs(id);
			if (attrs[this.attrIndexService.isNewDataKey]) {
				const feat = layer.getSource().getFeatureById(id);
				if (feat) {
					layer.getSource().removeFeature(feat);
				}
				return;
			}
			const origin = this.mainDataService.getDataOriginAttrs(id);
			if (!origin) {
				return;
			}
			if (origin[this.attrIndexService.geomColManual]) {
				let feature = layer.getSource().getFeatureById(id);
				if (!feature) {
					feature = new Feature();
					layer.getSource().addFeature(feature);
				}
				const geom = wktFormat.readGeometry(origin[this.attrIndexService.geomColManual]);
				feature.setGeometry(geom);
			}
		});
	}
}
